import { createRouteConfig } from 'modules/router/utils/createRouteConfig';

const REFERRALS_PATH = '/referrals/';

export const referralsRoutesConfig = createRouteConfig(
  {
    referrals: {
      path: REFERRALS_PATH,
      generatePath: () => REFERRALS_PATH,
    },
  },
  REFERRALS_PATH,
);
